import { render, staticRenderFns } from "./OrganizationCard.vue?vue&type=template&id=4eba0691&scoped=true&"
import script from "./OrganizationCard.vue?vue&type=script&lang=js&"
export * from "./OrganizationCard.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationCard.vue?vue&type=style&index=0&id=4eba0691&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eba0691",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VCol,VIcon,VImg,VRow,VSwitch})
